//interfaces
import { IDirectionalToggle } from "../../../../../interfaces/toggle";

//hooks
import UseDirectionalToggle from "./DirectionalToggle.hooks";



const DirectionalToggle = (props: IDirectionalToggle) => {
    const { getAriaLabel, handleClick, getImageSrc } = UseDirectionalToggle(props);

    return (
        <button className="toggle-caret" aria-label={getAriaLabel()} onClick={handleClick} >
            {props.text && <span>{props.text}</span>}
            <img src={getImageSrc()} alt="" aria-hidden="true" />
        </button>
    );
};

export default DirectionalToggle;